import { useApi } from '@omnipresentgroup/api';
import type {
  GetClientPolicyResponse,
  GetClientPolicyResponseAPI,
} from '@omnipresentgroup/types';
import { type UseQueryResult, useQuery } from '@tanstack/react-query';

import { API_BASE, CLIENT_POLICY_API_PATH } from '../constants';
import { transformGetClientPolicyResponseFromAPI } from '../mappers';

export const useClientPolicyDefaults = (): UseQueryResult<
  GetClientPolicyResponse,
  unknown
> => {
  const { GET } = useApi();

  return useQuery({
    queryKey: [CLIENT_POLICY_API_PATH],
    queryFn: () =>
      GET<GetClientPolicyResponseAPI>(
        `${API_BASE}/${CLIENT_POLICY_API_PATH}/defaults`,
      ),
    select: transformGetClientPolicyResponseFromAPI,
  });
};
